import { isNil } from '@lucidlink/tscore';
import { SettingValidationError } from '#common/types';
import { createPreencryptedSetting, createSetting } from './setting-impl';
import { OptionalBoolean } from './types';
import { InternalSettingType } from './types/setting';
export const createSettingsBuilder = (tupleWasm, configWasm) => {
    return new SettingsBuilderImpl(tupleWasm, configWasm);
};
class SettingsBuilderImpl {
    tupleWasm;
    configWasm;
    constructor(tupleWasm, configWasm) {
        this.tupleWasm = tupleWasm;
        this.configWasm = configWasm;
    }
    makeUint64(target, name, value) {
        return this.makeSetting(target, name, value.toString(), InternalSettingType.UINT64);
    }
    makeUint32(target, name, value) {
        return this.makeSetting(target, name, value.toString(), InternalSettingType.UINT32);
    }
    makeOptionalBoolean(target, name, value) {
        return this.makeUint32(target, name, value ? OptionalBoolean.TRUE : OptionalBoolean.FALSE);
    }
    makeBoolean(target, name, value) {
        const numberValue = value ? 1 : 0;
        return this.makeUint32(target, name, numberValue);
    }
    makeString(target, name, value) {
        return this.makeSetting(target, name, value, InternalSettingType.STRING);
    }
    makeBytes(target, name, value) {
        return this.makeSetting(target, name, value, InternalSettingType.STRING);
    }
    makeMultiString(target, name, value) {
        const settingFullName = { target, name };
        const rawSetting = this.configWasm.createMultiStringSetting(settingFullName, value);
        const setting = createSetting(rawSetting, this.tupleWasm, this.configWasm);
        this.validateSettingType(setting, InternalSettingType.MULTI_STRING);
        return setting;
    }
    parse(target, name, value) {
        return this.makeSetting(target, name, value, undefined);
    }
    makePreencrypted(target, name, value) {
        const settingFullName = {
            target: target,
            name: name,
        };
        const info = this.configWasm.getSettingDetails(settingFullName);
        return createPreencryptedSetting(settingFullName, value, info, this.tupleWasm, this.configWasm);
    }
    makeSetting(target, name, value, type) {
        const settingFullName = {
            target: target,
            name: name,
        };
        const rawSetting = this.configWasm.createSetting(settingFullName, value);
        const setting = createSetting(rawSetting, this.tupleWasm, this.configWasm);
        if (!isNil(type)) {
            this.validateSettingType(setting, type);
        }
        return setting;
    }
    validateSettingType(setting, type) {
        if (setting.details().internalType != type) {
            throw new SettingValidationError('Invalid setting type');
        }
    }
}
